module.exports = __webpack_public_path__ + "img/quadro-mulheres.a5a91d65.svg";